import React from 'react';
import { RoundsTable } from './RoundsTable';

export const RoundsList: React.FC = () => {
  return <RoundsTable />;
};
